import { HTTP } from '@/services/http'
import HardwareBookingFactory from '@/domain/services/HardwareBookingFactory'

const URL = 'api/users/me/business/projects/'
const MIDDLE_URL = '/hardware-booking'

const headers = {
  'Content-Type': 'application/json'
}

export function fetchAll (projectId) {
  const url = URL + projectId + MIDDLE_URL
  return HTTP.get(url)
    .then(response => response.data.collection.map(item => HardwareBookingFactory.get(item)))
}

export function fetchOneById (projectId, id) {
  const url = URL + projectId + MIDDLE_URL + '/' + id
  return HTTP.get(url)
    .then(response => HardwareBookingFactory.get(response.data))
}

export function createRequest (projectId, data) {
  const url = URL + projectId + MIDDLE_URL
  return HTTP.post(url, data, { headers })
    .then(response => HardwareBookingFactory.get(response.data))
}

export function updateRequest (projectId, data) {
  const entityToUpdate = Object.assign({}, data)
  const url = URL + projectId + MIDDLE_URL + '/' + entityToUpdate.id
  delete entityToUpdate.id
  return HTTP.put(url, entityToUpdate, { headers })
    .then(response => HardwareBookingFactory.get(response.data))
}

export function deleteRequest (projectId, id) {
  const url = URL + projectId + MIDDLE_URL + '/' + id
  return HTTP.delete(url)
    .then(response => response)
}

export function broadcastBookingRequest (projectId, booking) {
  const url = URL + projectId + MIDDLE_URL + '/' + booking.id + '/broadcast'
  const positions = {
    positions: booking.positions.map((position) => {
      return position.id
    })
  }
  return HTTP.post(url, positions, { headers: headers })
    .then(response => HardwareBookingFactory.get(response.data))
    .catch(error => {
      return Promise.reject(error)
    })
}
